module.exports = __webpack_public_path__ + "img/USA.2cb5719d.svg";